var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTapProject2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 3,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.42676 9.79883L7.00488 7.5332C7.23275 7.32487 7.41016 7.14909 7.53711 7.00586C7.66732 6.86263 7.76823 6.71777 7.83984 6.57129C7.91146 6.42155 7.94889 6.26042 7.95215 6.08789C7.94889 5.89583 7.90169 5.72819 7.81055 5.58496C7.72266 5.43848 7.60059 5.32617 7.44434 5.24805C7.29134 5.16992 7.11556 5.13086 6.91699 5.13086C6.611 5.13086 6.36686 5.22201 6.18457 5.4043C6.00228 5.58659 5.91113 5.83724 5.91113 6.15625H4.3291C4.3291 5.6875 4.43652 5.27734 4.65137 4.92578C4.86947 4.57422 5.17383 4.30404 5.56445 4.11523C5.95833 3.92643 6.41243 3.83203 6.92676 3.83203C7.45085 3.83203 7.91146 3.92155 8.30859 4.10059C8.70898 4.27637 9.01823 4.52539 9.23633 4.84766C9.45443 5.16992 9.56348 5.54102 9.56348 5.96094C9.56348 6.24089 9.50651 6.51107 9.39258 6.77148C9.2819 7.0319 9.08659 7.32161 8.80664 7.64062C8.52995 7.95638 8.1377 8.33724 7.62988 8.7832L6.74121 9.60352V9.65234H9.65137V11H4.42676V9.79883Z",
    fill: "#19191B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapProject2);
export default __webpack_public_path__ + "static/media/tap_project2.098b3275efef242986692ea34a8d9f6b.svg";
export { ForwardRef as ReactComponent };